<script>
    import {onMount, SvelteComponent} from "svelte";
    import { fade } from 'svelte/transition';
    import Fa from 'svelte-fa'
    import { faAngleLeft, faAngleRight, faForwardStep, faBackwardStep } from '@fortawesome/free-solid-svg-icons'
    import { Moon } from 'svelte-loading-spinners'
    import swipe from 'svelte-swipeable';
    import { oldTestamentBooks, newTestamentBooks } from "./constants/bibleBooks";
    import TileGroup from "./components/TileGroup.svelte";
    import ChapterText from "./components/ChapterText.svelte";
    import SelectionModal from "./components/SelectionModal.svelte";

    let selectedBook = null
    let selectedChapter = null
    let selectionModalIsOpen = false
    let showChapters = false
    let selectedBookTile

    $: if (selectedBook && selectedChapter) {
        chapterData = null
        fetchBibleChapter(selectedBook.value, selectedChapter + '').then(res => {
            localStorage.setItem('lastReadChapter', JSON.stringify({bookName: selectedBook.value, chapter: selectedChapter + ''}))
            chapterData = res
        })
    }

    onMount(() => {
        const data = JSON.parse(localStorage.getItem('lastReadChapter') || "{}")
        const bookName = data?.bookName ?? 'GENESIS'
        const chapter = data?.chapter ?? '1'
        selectedBook = oldTestamentBooks.concat(newTestamentBooks).find(book => book.value === bookName)
        selectedChapter = chapter
    })

    const selectBook = (id) => {
        selectedBook = oldTestamentBooks.concat(newTestamentBooks).find(book => book.abbrv === id)
    }

    let chapterData = null

    const toggleSelectionModal = () => {
        selectionModalIsOpen = !selectionModalIsOpen
    }

    const closeSelectionModal = () => {
        selectionModalIsOpen = false
    }

    const handleSelectTile = (e) => {
        selectedBook = e.detail.id
        showChapters = true
        selectedChapter = 1
    }

    const handleChapterSelect = (e) => {
        selectedChapter = e.detail.id.chapter
        closeSelectionModal()
    }

    const fetchBibleChapter = (bookName, chapterNumber) => {
        return fetch('https://7nb6tszpn0.execute-api.us-east-1.amazonaws.com/Dev/bible', {
            method: 'PUT',
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                bookName,
                chapterNumber
            }),
            redirect: 'follow'
        })
            .then(res => res.json())
    }

    const clearSelections = () => {
        showChapters = false
    }

    const findNextChapter = () => {
        const allBooks = oldTestamentBooks.concat(newTestamentBooks)
        let currentBookIndex = allBooks.findIndex(book => book.value === selectedBook.value)
        if (selectedChapter + 1 > selectedBook.chapters) {
            selectedChapter = 1
            if (currentBookIndex + 1 === allBooks.length) {
                currentBookIndex = 0
            } else {
                currentBookIndex++
            }
            selectedBook = allBooks[currentBookIndex]
        } else {
            selectedChapter++
        }
    }

    const findPreviousChapter = () => {
        const allBooks = oldTestamentBooks.concat(newTestamentBooks)
        let currentBookIndex = allBooks.findIndex(book => book.value === selectedBook.value)
        if (selectedChapter - 1 < 1) {
            if (currentBookIndex - 1 < 0) {
                currentBookIndex = (allBooks.length - 1)
            } else {
                currentBookIndex--
            }
            selectedChapter = allBooks[currentBookIndex].chapters
            selectedBook = allBooks[currentBookIndex]
        } else {
            selectedChapter--
        }
    }

</script>

<style>
    span.scale_icon:hover {
        transform: scale(1.2);
    }
</style>

<svelte:head>
    <title>Douay-Rheims Bible</title>
    <meta name="description" content="The traditional Catholic english translation of the Holy Bible, the Douay-Rheims translated from the Latin Vulgate">
</svelte:head>
<div class="bg-teal-700 text-white text-center fixed w-full z-20 mb-8">
    <p class="text-xl font-bold">The Holy Bible</p>
    <p class="text-sm">Douay-Rheims Translation, Challoner Revision</p>
</div>
<div class="p-2 bg-gray-50 pt-12">
    <div class="flex justify-center underline">
        <button class="mx-auto w-1/3" on:click={toggleSelectionModal}>Table of Contents</button>
    </div>
    {#if selectionModalIsOpen}
        <SelectionModal
            on:handleChapterSelect={handleChapterSelect}
            on:handleSelectTile={handleSelectTile}
            on:clearSelections={clearSelections}
            on:closeSelectionModal={closeSelectionModal}
            {selectedBook}
            {showChapters}
        />
    {/if}
</div>
<div class="bg-gray-50 pb-8">
    {#if chapterData}
        <div class="flex" use:swipe={{threshX: 100,  threshY: 200}} on:swipeRight={findNextChapter} on:swipeLeft={findPreviousChapter}>
            <span on:click={findPreviousChapter} class="hover:bg-gray-100 m-2 rounded-xl justify-center fixed hidden md:block h-full">
                <Fa icon={faAngleLeft} size="4x" color="#999" class="md:mt-20"/>
            </span>
            <ChapterText bookName={selectedBook.label} chapterNumber={selectedChapter} chapterData={chapterData}/>
            <div on:click={findNextChapter} class="hover:bg-gray-100 m-2 rounded-xl justify-center fixed hidden md:block right-0 h-full">
                <Fa icon={faAngleRight} size="4x" color="#999" class="md:mt-20"/>
            </div>
        </div>
    {:else}
        <div class="h-screen w-screen flex justify-center items-center">
            <Moon size="60" color="#0f766e" unit="px" duration="1s" class="mx-auto my-auto"/>
        </div>
    {/if}
</div>
<div class="bottom-0 bg-teal-700 text-white text-center fixed md:hidden w-full z-20">
    <div class="flex justify-around">
        <span on:click={findPreviousChapter} class="">
            <Fa icon={faBackwardStep} size="2x" color="#FFF" class=""/>
        </span>
        <span on:click={findNextChapter} class="">
            <Fa icon={faForwardStep} size="2x" color="#FFF" class=""/>
        </span>
    </div>
</div>
